import { useState } from "react";

export interface HoverPopover {
  anchorEl: HTMLElement | null;
  open: boolean;
  onTriggerEnter: (e: React.MouseEvent<HTMLElement>) => void;
  onTriggerLeave: () => void;
  onCardEnter: () => void;
  onCardLeave: () => void;
}

export const useHoverPopover = (): HoverPopover => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [isOverTrigger, setIsOverTrigger] = useState(false);
  const [isOverCard, setIsOverCard] = useState(false);

  return {
    anchorEl,
    open: isOverTrigger || isOverCard,
    onTriggerEnter: (e) => {
      setAnchorEl(e.currentTarget);
      setIsOverTrigger(true);
    },
    onTriggerLeave: () => setIsOverTrigger(false),
    onCardEnter: () => setIsOverCard(true),
    onCardLeave: () => setIsOverCard(false),
  };
};
